<template>
  <div class="picture-course-detail">
    <div class="content" v-html="content"></div>
  </div>
</template>

<script>
export default {
  name: "picture-course-detail",
  data() {
    return {
      title: {
        name: this.$route.query.chapter_name
      },
      content: ""
    };
  },
  created() {
    this.requestDetail();
  },
  methods: {
    // request
    requestDetail() {
      this.$http
        .get(`/api/app/chapterInfo/${this.$route.query.chapter_id}`, {
          system_course_id: this.$route.query.system_course_id
        })
        .then(data => {
          this.content = data.course_content;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.picture-course-detail {
  .header {
    border-bottom: 1px solid #f5f5f5;
  }
  .content {
    padding: 30px 20px;
    font-size: 32px;
    font-weight: 400;
    /deep/ img {
      max-width: 100%;
      display: block;
    }
  }
}
</style>